import { Color, GameObj, Vec2 } from 'kaplay';
import { Colors } from '../constants/colors';

// params should be what is passed into Circle
export function addCircle({ pos, color }: { pos: Vec2; color: Color }): GameObj {
  const circle = add([]);

  circle.onDraw(() => {
    // draw an outline so the circle is more defined
    drawCircle({
      pos,
      color: rgb(...(Colors.BLACK as [number, number, number])),
      radius: 32,
    });
    // then draw the actual color
    drawCircle({
      pos,
      color,
      radius: 30,
    });
  });

  return circle;
}
